import { projectSettingsServicedeskProactiveSupportRoute } from '@jira/router-routes__project-settings-service-desk-proactive-support-routes/src/projectSettingsServicedeskProactiveSupportRoute.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskProactiveSupportAppEntryPoint } from '@jira/spa-apps__project-settings-service-desk-proactive-support/src/projectSettingsServicedeskProactiveSupport.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const projectSettingsServicedeskProactiveSupportPageEntry = createPageEntryPoint({
	main: projectSettingsServicedeskProactiveSupportAppEntryPoint,
});

export const projectSettingsServicedeskProactiveSupportRouteEntry: Route = createEntry(
	projectSettingsServicedeskProactiveSupportRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'project-settings-servicedesk.proactive-support',
		perfMetricKey: 'project-settings-servicedesk.proactive-support',

		entryPoint: () => {
			return fg('jsm_psm_visible')
				? projectSettingsServicedeskProactiveSupportPageEntry
				: notFoundPageEntrypoint;
		},

		navigation: {
			menuId: 'PROJECTS',
			sidebarId: 'PROJECT_SETTINGS',
		},

		resources: [
			...getServiceDeskSettingsResources().map((resource) =>
				resourceWithCondition(() => fg('jsm_psm_visible'), resource),
			),
		],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
